import styled, { css, WebTarget } from 'styled-components';

const makeInvertable = (Component: WebTarget, initialDir: 'row' | 'column') => styled(Component)`
    flex-direction: ${({ $inverted }) => $inverted ? `${initialDir}-reverse` : initialDir};
`;

export const makeCentered = (Component: WebTarget, { x, y }: { x?: boolean, y?: boolean } = { x: true, y: true }) => {
    const styles: string[] = [];

    if (x) {
        styles.push('justify-content: center;');
    }

    if (y) {
        styles.push('align-items: center;');
    }

    return styled(Component)(() => css`
        ${styles.join('')}
    `);
};

export const Flex4XS = styled.div`
    display: flex;
    gap: ${({ theme }) => theme.spacing['4xs']};
`;

export const FlexCol4XS = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing['4xs']};
`;

export const FlexCol3XS = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing['3xs']};
`;

export const FlexCol3XL = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing['3xl']};
`;

export const Flex3XS = makeInvertable(styled.div`
    display: flex;
    gap: ${({ theme }) => theme.spacing['3xs']};
`, 'row');

export const Flex3XSCentered = makeCentered(Flex3XS);

export const FlexCenter3XS = makeCentered(Flex3XS, {
    x: false,
    y: true
});

export const FlexCol2XS = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing['2xs']};
`;

export const Flex2XS = makeInvertable(styled.div`
    display: flex;
    gap: ${({ theme }) => theme.spacing['2xs']};
`, 'row');

export const FlexLG = makeInvertable(styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.lg};
`, 'row');

export const FlexColXS = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.xs};
`;

export const FlexColMD = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.md};
`;

export const FlexMD = styled.div`
    display: flex;
    gap: ${({ theme }) => theme.spacing.md};
`;

export const FlexColSM = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.sm};
`;

export const FlexXS = styled.div`
    display: flex;
    gap: ${({ theme }) => theme.spacing.xs};
`;

export const FlexSM = styled.div`
    display: flex;
    height: 100%;
    gap: ${({ theme }) => theme.spacing.sm};
`;

export const FlexSpaceBetween = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const Flex = styled.div`
    display: flex;
`;

export const FlexCol = styled.div`
    display: flex;
    flex-direction: column;
`;

export const FullHeightFlexCol = styled(FlexCol)`
  height: 100%;
`;
